export const applyFormScroll = () => {
  if (document.body.classList.contains("trabajo")) {
    const applyLink = document.querySelector(".apply__btn");
    const applyForm = document.querySelector(".apply__form__container");

    applyLink.addEventListener("click", (e) => {
      e.preventDefault();
      applyForm.scrollIntoView({ behavior: "smooth" });
    });
  }
};
